"use client";

import type { FC, PropsWithChildren } from "react";
import { ConfigContext, type ConfigContextValue } from "./ConfigContext";

type Props = PropsWithChildren<{ config: ConfigContextValue }>;

export const ConfigContextProvider: FC<Props> = ({ children, config }) => {
	return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};
